export default "__VITE_ASSET__rORt_lCU__"